import { Tag } from 'antd'
import React from 'react'

const SeletedLineItem = ({ selectedValue = [] }) => {

    const userData = JSON.parse(localStorage.getItem('userData'));
    console.log(userData.data.full_name);

    const tagStyle ={padding: "10px", backgroundColor: "transparent", border: "none"};

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "30px",
            }}
        >

            <div style={{ display: "flex", gap: "10px" }}>
                <Tag style={tagStyle} >
                    <p style={{ fontSize: "15px", margin: 0, color:'black' }}>
                        <strong>{selectedValue.line || "Line Not Selected"}</strong>
                    </p>
                </Tag>
                <Tag style={tagStyle} >
                    <p style={{ fontSize: "15px", margin: 0, color:'black' }}>
                        <strong>Item : {selectedValue.item || "Not Selected"}</strong>
                    </p>
                </Tag>
            </div>

            <Tag
                style={{
                    width: "auto",
                    marginLeft: "auto", 
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",...tagStyle,
                }}
            >
                <p style={{ fontSize: "15px", margin: 0, textAlign: "center", color:'black' }}>
                    <strong>{userData.data.full_name || "Not Found"}</strong>
                </p>
            </Tag>

        </div>
    )
}

export default SeletedLineItem